/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...
document.addEventListener('DOMContentLoaded', () => {
  const injectFont = (shadow) => {
    if (shadow.querySelector('style[data-custom-font]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-custom-font', '');
    style.textContent = `* { font-family: 'SoehneMonoBuch', monospace !important; }`;
    shadow.appendChild(style);
  };

  const tryInject = () => {
    const formsEmbed = document.querySelector('shopify-forms-embed');
    if (!formsEmbed) return false;
    if (formsEmbed.shadowRoot) {
      injectFont(formsEmbed.shadowRoot);
      return true;
    }
    return false;
  };

  if (!tryInject()) {
    const observer = new MutationObserver(() => {
      if (tryInject()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
});
